import LocationForm from './LocationForm'
export {LocationForm}
export default LocationForm
